module.exports = __webpack_public_path__ + "media/images/emblems/Cama_wappen-74254f408bf95a6e77e1ad2d8359fa77.svg";